import React, { useEffect, useState } from "react";

import Page from "./Page";
import Toast from "../../Utils/Toast";
import BoxBashgah from "../../Components/componentBashgah/BoxBashgah";
import {
  Transaction_Club,
  Transaction_Profile,
} from "../../Connections/Transaction";

import "../../Styles/Bashgah.css";
import MobileNavBar from "../../Components/Navs/MobileNavBar";
import { useNavigate } from "react-router";
import PictureProfile from "../../Containers/Profile/PictureProfile";

const Bashgah = () => {
  const navigator = useNavigate();

  // ==========================================================

  const [showFilter, setShowFilter] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [awardsCategory, setAwardsCategory] = useState([]);
  const [awardList, setAwardList] = useState([]);

  const [mostInviteList, setMostInviteList] = useState([]);
  const [bestOfCampaignList, setBestOfCampaignList] = useState([]);
  const [mostLikeList, setMostLikeList] = useState([]);
  const [medalList, setMedalList] = useState([]);

  // ==========================================================

  const copyToClipBoard = async (text) => {
    await navigator.clipboard.writeText(text);
  };

  const getAwards = (id) => {
    Transaction_Club.GetAwards(id)
      .then((res) => {
        if (res[0]) {
          setAwardList(res[2].data);
        }
      })
      .catch((err) => console.log(err));
  };

  const takeAward = (id) => {
    const form = new FormData();
    form.append("AwardId", id);
    Transaction_Club.TakeAward(form)
      .then((res) => {
        if (res[0]) {
          copyToClipBoard(res[2].data.awardCode);
          getAwards(id);
          Toast("success", "کد تخفیف با موفقیت کپی شد!");
        } else {
          Toast("error", res[1]);
        }
      })
      .catch((err) => console.log(err));
  };

  // ==========================================================

  useEffect(() => {
    Transaction_Club.GetHomeClub()
      .then((res) => {
        if (res[0]) setUserInfo(res[2].data);
      })
      .catch((err) => console.log(err));

    Transaction_Club.GetMostInvite()
      .then((res) => {
        if (res[0]) {
          setMostInviteList(res[2].data);
        }
      })
      .catch((err) => console.log(err));

    Transaction_Club.GetBestOfCampaign()
      .then((res) => {
        if (res[0]) {
          setBestOfCampaignList(res[2].data);
        }
      })
      .catch((err) => console.log(err));

    Transaction_Club.GetMostLike()
      .then((res) => {
        if (res[0]) {
          setMostLikeList(res[2].data);
        }
      })
      .catch((err) => console.log(err));

    Transaction_Club.GetAwardCategories()
      .then((res) => {
        if (res[0]) {
          setAwardsCategory(res[2].data);
          // getAwards(res[2].data[0].id);
        }
      })
      .catch((err) => console.log(err));

    Transaction_Club.GetBestMedalists()
      .then((res) => {
        if (res[0]) {
          setMedalList(res[2].data);
        }
      })
      .catch((err) => console.log(err));

    Transaction_Club.GetAwards()
      .then((res) => {
        if (res[0]) {
          setAwardList(res[2].data);
        }
      })
      .catch((err) => console.log(err));
  }, []);

  // ==========================================================

  const [user, setUser] = useState({});

  const getProfile = () => {
    Transaction_Profile.GetProfile().then((res) => {
      if (res[0]) setUser(res[2].data);
    });
  };

  useEffect(() => {
    getProfile();
  }, []);

  // ==========================================================

  const checkChanceGoldBox = (id) => {
    const form = new FormData();
    form.append("choice", id);
    Transaction_Club.AddGoldBox(form)
      .then((res) => {
        if (res[0]) {
          console.log(res);
          Toast("success", res[1]);
        } else {
          Toast("error", res[1]);
        }
      })
      .catch((err) => console.log(err));
  };

  // ==========================================================

  return (
    <Page>
      <MobileNavBar
        text={"باشگاه"}
        action={() => navigator("/hisstori/home")}
      />
      <div className="Bashgah">
        <div className="Bashgah-inside">
          <div className="Bashgah-inside-item1">
            {window.outerWidth < 993 ? (
              <div
                style={{ marginTop: "-115px", zIndex: 40 }}
                className="Bashgah-inside-item1-res"
              >
                <div className="Bashgah-inside-item1-res-top">
                  <div className="Bashgah-inside-item1-res-top-box margin-box-res">
                    <div
                      className="Bashgah-inside-item1-res-box-inside"
                      onClick={() =>
                        navigator("/hisstori/club/my-coins", {
                          state: { from: "club" },
                        })
                      }
                    >
                      <img
                        className="Bashgah-inside-item1-res-box-inside-img"
                        src="/imgs/bashgah/bashgah-seke.svg"
                      />
                      <p className="Bashgah-inside-item1-res-box-inside-text number-font">
                        {userInfo.coins} سکه
                      </p>
                    </div>
                  </div>
                  <div className="Bashgah-inside-item1-res-top-box margin-box-res">
                    <div
                      className="Bashgah-inside-item1-res-box-inside"
                      onClick={() =>
                        navigator("/hisstori/club/my-scores", {
                          state: { from: "club" },
                        })
                      }
                    >
                      <img
                        className="Bashgah-inside-item1-res-box-inside-img"
                        src="/imgs/bashgah/bashgah-group.svg"
                      />
                      <p className="Bashgah-inside-item1-res-box-inside-text number-font">
                        {userInfo.scores} امتیاز
                      </p>
                    </div>
                  </div>
                  <div
                    className="Bashgah-inside-item1-res-top-box"
                    onClick={() =>
                      navigator("/hisstori/club/invite-friend", {
                        state: { from: "club" },
                      })
                    }
                  >
                    <div className="Bashgah-inside-item1-res-box-inside">
                      <img
                        className="Bashgah-inside-item1-res-box-inside-img"
                        src="/imgs/bashgah/bashgah-user.svg"
                      />
                      <p className="Bashgah-inside-item1-res-box-inside-text number-font">
                        {userInfo.invites} دعوت دوست
                      </p>
                    </div>
                  </div>
                </div>
                <div className="Bashgah-inside-item1-res-bottom">
                  <div className="Bashgah-inside-item1-res-top-box margin-box-res">
                    <div
                      className="Bashgah-inside-item1-res-box-inside"
                      onClick={() =>
                        navigator("/hisstori/club/my-medals", {
                          state: { from: "club" },
                        })
                      }
                    >
                      <img
                        className="Bashgah-inside-item1-res-box-inside-img"
                        src="/imgs/bashgah/bashgah-medal.svg"
                      />
                      <p className="Bashgah-inside-item1-res-box-inside-text number-font">
                        {userInfo.medals} مدال
                      </p>
                    </div>
                  </div>
                  <div
                    className="Bashgah-inside-item1-res-top-box margin-box-res"
                    // onClick={() =>
                    //   navigator("/hisstori/club/free-discussion", {
                    //     state: { from: "club" },
                    //   })
                    // }
                  >
                    <div className="Bashgah-inside-item1-res-box-inside">
                      <img
                        className="Bashgah-inside-item1-res-box-inside-img"
                        src="/imgs/bashgah/bashgah-heart.svg"
                      />
                      <p className="Bashgah-inside-item1-res-box-inside-text number-font">
                        {userInfo.likes} لایک دریافتی
                      </p>
                    </div>
                  </div>
                  <div
                    className="Bashgah-inside-item1-res-top-box"
                    onClick={() =>
                      navigator("/hisstori/club/my-signs", {
                        state: { from: "club" },
                      })
                    }
                  >
                    <div className="Bashgah-inside-item1-res-box-inside">
                      <img
                        className="Bashgah-inside-item1-res-box-inside-img"
                        src="/imgs/bashgah/bashgah-tala.svg"
                      />
                      <p className="Bashgah-inside-item1-res-box-inside-text number-font">
                        {userInfo.signs} نشان
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            <div className="Bashgah-inside-item1-reght Bashgah-inside-item1-reght-up">
              <div className="Bashgah-inside-item1-reght-text">
                <p className="Bashgah-inside-item1-reght-name">{user.name}</p>
                <p className="Bashgah-inside-item1-reght-number number-font">
                  {user.mobile}
                </p>
              </div>
            </div>
            <div className="Bashgah-inside-item1-left">
              <div className="Profile-top">
                <div className="Profile-top-right">
                  <div className="Profile-top-right-inside">
                    <div className="Profile-top-right-inside-text">
                      {/* <div className="Profile-top-right-inside-text-display">
                        <p
                          className="Profile-top-right-inside-text-name"
                          style={{ textAlign: "center" }}
                        >
                          {user.name || "کاربر"}
                        </p>
                        <p className="Profile-top-right-inside-text-phone number-font">
                          {user.mobile}
                        </p>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="Profile-top-left">
                  <PictureProfile profileSrc={user.avatar} iconChange={false} />
                </div>
              </div>
            </div>
          </div>
          {window.outerWidth > 993 ? (
            <div className="parent-score">
              {/* score item 1  */}
              <div
                onClick={() =>
                  navigator("/hisstori/club/my-coins", {
                    state: { from: "club" },
                  })
                }
                className="score-item"
              >
                <img src="/imgs/bashgah/bashgah-seke.svg" />
                <p> {userInfo.coins} سکه</p>
              </div>
              {/* score item 2  */}
              <div
                onClick={() =>
                  navigator("/hisstori/club/my-scores", {
                    state: { from: "club" },
                  })
                }
                className="score-item"
              >
                <img src="/imgs/bashgah/bashgah-group.svg" />
                <p>{userInfo.scores} امتیاز</p>
              </div>
              {/* score item 3  */}
              <div
                onClick={() =>
                  navigator("/hisstori/club/invite-friend", {
                    state: { from: "club" },
                  })
                }
                className="score-item"
              >
                <img src="/imgs/bashgah/bashgah-user.svg" />
                <p>{userInfo.invites} دعوت دوست</p>
              </div>
              {/* score item 4  */}
              <div
                onClick={() =>
                  navigator("/hisstori/club/my-medals", {
                    state: { from: "club" },
                  })
                }
                className="score-item"
              >
                <img src="/imgs/bashgah/bashgah-medal.svg" />
                <p>{userInfo.medals} مدال</p>
              </div>
              {/* score item 5  */}
              <div className="score-item">
                <img src="/imgs/bashgah/bashgah-heart.svg" />
                <p>{userInfo.likes} لایک دریافتی</p>
              </div>
              {/* score item 6  */}
              <div
                onClick={() =>
                  navigator("/hisstori/club/my-signs", {
                    state: { from: "club" },
                  })
                }
                className="score-item"
              >
                <img src="/imgs/bashgah/bashgah-tala.svg" />
                <p>{userInfo.signs} نشان</p>
              </div>
            </div>
          ) : null}
          <div className="Bashgah-inside-item2">
            <div className="Bashgah-inside-item2-right">
              <div className="Bashgah-inside-item2-right-inside">
                <p className="Bashgah-inside-item2-right-inside-title">
                  صندوق گنج
                </p>
                <p className="Bashgah-inside-item2-right-inside-text">
                  میتونی هر روز با انتخاب درست یه کلید برای صندوق گنج, کلی جایزه
                  بگیری و به تعداد سکه‌هات اضافه کنی.
                </p>
                <div className="desktop-hidden">
                  <img className="" src="/imgs/bashgah/Sketch-res.svg" />
                </div>
                <div className="Bashgah-inside-item2-right-inside-image1">
                  <img
                    className="Bashgah-inside-item2-right-inside-image1-img"
                    src="/imgs/bashgah/bashgah-ganj.svg"
                  />
                </div>
                <div className="Bashgah-inside-item2-right-inside-image2">
                  <img
                    onClick={() => checkChanceGoldBox(1)}
                    className="Bashgah-inside-item2-right-inside-image2-img"
                    src="/imgs/bashgah/key2.svg"
                  />
                  <img
                    onClick={() => checkChanceGoldBox(2)}
                    className="Bashgah-inside-item2-right-inside-image2-img"
                    src="/imgs/bashgah/key3.svg"
                  />
                  <img
                    onClick={() => checkChanceGoldBox(3)}
                    className="Bashgah-inside-item2-right-inside-image2-img"
                    src="/imgs/bashgah/key1.svg"
                  />
                </div>
              </div>
            </div>
            <div
              style={{ position: "relative" }}
              className="Bashgah-inside-item2-right"
            >
              <div
                style={{ paddingTop: "33px" }}
                className="Bashgah-inside-item2-right-inside"
              >
                {/* <div className="desktop-hidden">
                  <img
                    className=""
                    src="/imgs/bashgah/hisstoriPlus-dahsed-light.svg"
                  />
                </div> */}
                <div className="Bashgah-inside-item2-right-inside-image1 mobile-hidden">
                  <img
                    className="Bashgah-inside-item2-right-inside-image1-img"
                    src="/imgs/bashgah/hisstoriPlus-dahsed.svg"
                  />
                </div>
                <div className="Bashgah-inside-item2-right-inside-image1 desktop-hidden">
                  <img
                    className="Bashgah-inside-item2-right-inside-image1-img"
                    src="/imgs/bashgah/hisstoriPlus-dahsed-light.svg"
                  />
                </div>

                <p className="Bashgah-inside-item2-description-hisstoriPlus">
                  تو هیس‌طوری پلاس یه عالمه راه جدید هست برای اینکه بتونی کلیییی
                  امتیاز بگیری!
                </p>
                <div
                  style={{
                    alignItems: "flex-end",
                    justifyContent: "center",
                  }}
                  className="Bashgah-inside-item2-right-inside-image2"
                >
                  <img
                    className="Bashgah-inside-item2-right-book-img"
                    src="/imgs/hisstoriPlus/plus-banner-index.svg"
                  />
                  <div
                    style={{
                      display: "flex",
                      alignItems: "flex-end",
                      justifyContent: "center",
                    }}
                    className="Bashgah-inside-item2-btn-go"
                  >
                    <div className="desktop-hidden">
                      <img className="" src="/imgs/bashgah/Sketch-res.svg" />
                    </div>
                    <button
                      onClick={() => navigator("/hisstori/plus")}
                      style={{ height: "fit-content" }}
                      className="Profile-top-right-inside-button-edit"
                    >
                      بزن بریم...!
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="Bashgah-inside-item2-left ">
              <div className="Bashgah-inside-item2-left-top">
                <div className="Bashgah-inside-item2-left-box">
                  <div
                    className="Bashgah-inside-item2-left-box-inside"
                    onClick={() =>
                      navigator("/hisstori/club/my-coins", {
                        state: { from: "club" },
                      })
                    }
                  >
                    <div className="Bashgah-box">
                      <img
                        className="Bashgah-inside-item2-left-box-img"
                        src="/imgs/bashgah/bashgah-seke.svg"
                      />
                    </div>
                    <div className="Bashgah-box">
                      <p className="Bashgah-inside-item2-left-box-text number-font">
                        {userInfo.coins} سکه
                      </p>
                    </div>
                  </div>
                </div>
                <div className="Bashgah-inside-item2-left-box left">
                  <div
                    className="Bashgah-inside-item2-left-box-inside"
                    onClick={() =>
                      navigator("/hisstori/club/my-scores", {
                        state: { from: "club" },
                      })
                    }
                  >
                    <img
                      className="Bashgah-inside-item2-left-box-img group"
                      src="/imgs/bashgah/bashgah-group.svg"
                    />
                    <p className="Bashgah-inside-item2-left-box-text number-font">
                      {userInfo.scores} امتیاز
                    </p>
                  </div>
                </div>
              </div>
              <div className="Bashgah-inside-item2-left-center">
                <div className="Bashgah-inside-item2-left-box">
                  <div
                    className="Bashgah-inside-item2-left-box-inside"
                    onClick={() =>
                      navigator("/hisstori/club/my-medals", {
                        state: { from: "club" },
                      })
                    }
                  >
                    <img
                      className="Bashgah-inside-item2-left-box-img"
                      src="/imgs/bashgah/bashgah-medal.svg"
                    />
                    <p className="Bashgah-inside-item2-left-box-text number-font">
                      {userInfo.medals} مدال
                    </p>
                  </div>
                </div>
                <div className="Bashgah-inside-item2-left-box left">
                  <div
                    className="Bashgah-inside-item2-left-box-inside"
                    onClick={() =>
                      navigator("/hisstori/club/invite-friend", {
                        state: { from: "club" },
                      })
                    }
                  >
                    <img
                      className="Bashgah-inside-item2-left-box-img"
                      src="/imgs/bashgah/bashgah-user.svg"
                    />
                    <p className="Bashgah-inside-item2-left-box-text number-font">
                      {userInfo.invites} دعوت دوست
                    </p>
                  </div>
                </div>
              </div>
              <div className="Bashgah-inside-item2-left-bottom">
                <div className="Bashgah-inside-item2-left-box">
                  <div
                    className="Bashgah-inside-item2-left-box-inside"
                    // onClick={() =>
                    //   navigator("/hisstori/club/free-discussion", {
                    //     state: { from: "club" },
                    //   })
                    // }
                  >
                    <img
                      className="Bashgah-inside-item2-left-box-img"
                      src="/imgs/bashgah/bashgah-heart.svg"
                    />
                    <p className="Bashgah-inside-item2-left-box-text number-font">
                      {userInfo.likes} لایک دریافتی
                    </p>
                  </div>
                </div>
                <div className="Bashgah-inside-item2-left-box">
                  <div
                    className="Bashgah-inside-item2-left-box-inside"
                    onClick={() =>
                      navigator("/hisstori/club/my-signs", {
                        state: { from: "club" },
                      })
                    }
                  >
                    <img
                      className="Bashgah-inside-item2-left-box-img"
                      src="/imgs/bashgah/bashgah-tala.svg"
                    />
                    <p className="Bashgah-inside-item2-left-box-text number-font">
                      {userInfo.signs} نشان
                    </p>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          <div className="Bashgah-inside-item3">
            <div className="Bashgah-inside-item3-right">
              <div className="Bashgah-inside-item4-right-box">
                <BoxBashgah
                  title={"نفرات برتر پویش"}
                  info={bestOfCampaignList}
                />
              </div>
            </div>
            <div className="Bashgah-inside-item3-left">
              <div className="Bashgah-inside-item4-right-box">
                <BoxBashgah
                  title={"بیشترین دعوت از دوستان"}
                  info={mostInviteList}
                />
              </div>
            </div>
          </div>

          <div className="Bashgah-inside-item4">
            <div className="Bashgah-inside-item4-right">
              <div className="Bashgah-inside-item4-right-box">
                <BoxBashgah
                  title={" بیشترین لایک دریافتی"}
                  info={mostLikeList}
                />
              </div>
            </div>
            <div className="Bashgah-inside-item4-left">
              <div className="Bashgah-inside-item4-left-b">
                <div className="Bashgah-inside-item4-left-inside">
                  <div className="Bashgah-inside-item4-left-inside-top">
                    <div className="Bashgah-inside-item4-left-image">
                      <img
                        className="Bashgah-inside-item4-left-image-img"
                        src="/imgs/bashgah/medalTala.svg"
                      />
                    </div>
                    <p className="Bashgah-inside-item4-left-inside-title">
                      مدال آورهای طلایی
                    </p>
                  </div>

                  {medalList.map((item) => (
                    <div className="Bashgah-inside-item4-left-inside-item">
                      <div className="Bashgah-inside-item4-left-inside-item-right">
                        <p className="Bashgah-inside-item4-left-inside-item-right-text">
                          {item.medalName}
                        </p>
                      </div>
                      <div className="Bashgah-inside-item4-left-inside-item-left">
                        <p className="Bashgah-inside-item4-left-inside-item-left-text number-font">
                          {item.numberOfMedalists} نفر
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="Bashgah-inside-item5">
            <div className="Bashgah-inside-item5-top">
              <div className="Bashgah-inside-item5-top-border">
                <div className="Bashgah-inside-item5-top-right">
                  <p className="Bashgah-inside-item5-top-right-text">
                    جایزه ها
                  </p>
                </div>
                <div
                  className="Bashgah-inside-item5-top-left"
                  onClick={() => setShowFilter(!showFilter)}
                >
                  {showFilter ? (
                    <div className="filter">
                      <div className="filter-inside">
                        {awardsCategory.map((item) => (
                          <p
                            className="filter-inside-text"
                            key={item.id}
                            onClick={() => getAwards(item.id)}
                          >
                            {item.title}
                          </p>
                        ))}
                      </div>
                    </div>
                  ) : null}
                  <img
                    style={{ cursor: "pointer" }}
                    className="Bashgah-inside-item5-top-left-img"
                    src="/imgs/bashgah/bashgah-jayeze.svg"
                  />
                </div>
              </div>
            </div>
            <div
              className="Bashgah-inside-item5-center"
              onClick={() => navigator("/offer-codes")}
            >
              <img
                className="Bashgah-inside-item5-center-img"
                src="/imgs/bashgah/iconCode.svg"
              />
              <p className="Bashgah-inside-item5-center-text">
                کدهـای تخفیـف مـن
              </p>
            </div>
            <div className="Bashgah-inside-item5-bottom">
              {awardList.map((item) => (
                <div className="Bashgah-inside-item5-bottom-box" key={item.id}>
                  <div className="Bashgah-inside-item5-bottom-box-image">
                    <img
                      className="Bashgah-inside-item5-bottom-box-image-img"
                      src={item.pic}
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      height: "100%",
                    }}
                    className="Bashgah-inside-item5-bottom-box-inside"
                  >
                    <div>
                      <p className="Bashgah-inside-item5-bottom-box-inside-title number-font">
                        {item.title}
                      </p>
                      <p className="Bashgah-inside-item5-bottom-box-inside-text">
                        {item.detail}
                      </p>
                    </div>
                    <div
                      onClick={() => takeAward(item.id)}
                      className="Bashgah-inside-item5-bottom-box-inside-bottom"
                    >
                      <div className="Bashgah-inside-item5-bottom-box-inside-bottom-inside">
                        <p className="Bashgah-inside-item5-bottom-box-inside-bottom-text number-font">
                          {item.coinRequired} سکه
                        </p>
                        <img src="/imgs/bashgah/bashgah-seke-j.svg" />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};
export default Bashgah;
